<script setup lang="ts">
import { InputNumber } from 'primevue';
const model = defineModel<number>();
</script>

<template>
  <InputNumber v-model:model-value="model" show-buttons
    button-layout="horizontal" fluid :step="1" mode="decimal" :minFractionDigits="0" :maxFractionDigits="3">
    <template #incrementicon>
      <span class="pi pi-plus" />
    </template>
    <template #decrementicon>
      <span class="pi pi-minus" />
    </template>
  </InputNumber>
</template>

<style scoped>

:deep(.p-inputnumber-input) {
  text-align: end;
}

</style>
